import axios from "axios";

const BFF_URL = process.env.REACT_APP_SELF_LEARNING_BFF_URL;
const BFF_FALLBACK_URL = process.env.REACT_APP_SELF_LEARNING_BFF_FALLBACK_URL;
const BFF_API_KEY = process.env.REACT_APP_SELF_LEARNING_BFF_URL_API_KEY;
const USE_BFF =
  String(process.env.REACT_APP_USE_SELF_LEARNING_BFF || "").toLowerCase() ===
  "true";

export function isSelfLearningBffEnabled() {
  return USE_BFF && !!(BFF_URL || BFF_FALLBACK_URL);
}

function createClient(baseURL, extraHeaders) {
  return axios.create({
    baseURL: baseURL,
    timeout: 60000,
    headers: Object.assign(
      {
        "x-api-key": BFF_API_KEY || "",
      },
      extraHeaders || {},
    ),
  });
}

function bffBases() {
  var bases = [];
  if (BFF_URL) bases.push(BFF_URL);
  if (BFF_FALLBACK_URL && BFF_FALLBACK_URL !== BFF_URL) {
    bases.push(BFF_FALLBACK_URL);
  }
  return bases;
}

async function bffRequest(exec, extraHeaders) {
  var bases = bffBases();
  var lastError = null;
  for (var i = 0; i < bases.length; i++) {
    try {
      return await exec(createClient(bases[i], extraHeaders));
    } catch (err) {
      lastError = err;
      var status = err && err.response && err.response.status;
      // Same Catchup API key cannot unlock a second BFF host (STG 401s).
      // 4xx from the primary is the real contract; do not retry it.
      if (status && status >= 400 && status < 500) {
        throw err;
      }
    }
  }
  throw lastError || new Error("Self Learning BFF is not configured.");
}

export function unwrapBff(res) {
  var payload = res && res.data;
  if (payload && payload.success === true && payload.data !== undefined) {
    return payload.data;
  }
  return payload;
}

export async function bffStudentAuth(body) {
  return bffRequest(function (client) {
    return client.post("/api/student/auth", body);
  });
}

export async function bffGetStudentEnrollments(studentId) {
  return bffRequest(function (client) {
    return client.get("/api/student/enrollments", {
      params: { studentId: studentId },
    });
  });
}

export async function bffGetUserByAccessToken(accessToken) {
  return bffRequest(function (client) {
    return client.post("/wizme/user", { accessToken: accessToken });
  });
}

export async function bffGetCatchupLessons(bookId, params, authorization) {
  return bffRequest(
    function (client) {
      return client.get(
        "/api/books/" + encodeURIComponent(bookId) + "/lessons",
        {
          params: Object.assign({ content: "backbone" }, params || {}),
        },
      );
    },
    authorization ? { Authorization: authorization } : {},
  );
}

export async function bffGetCatchupLessonContent(bookId, lessonId, authorization) {
  return bffRequest(
    function (client) {
      return client.get(
        "/api/books/" +
          encodeURIComponent(bookId) +
          "/lessons/" +
          encodeURIComponent(lessonId),
        { params: { content: "backbone" } },
      );
    },
    authorization ? { Authorization: authorization } : {},
  );
}
